import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { formRules } from "@/js/form_rules.js";
import { request } from "@/js/http/http_request";
import { DOCUMENT_TAGS } from "@/js/lists.ts";
export default {
  name: "AddTagToDocumentDialog",
  props: {
    isTagYourInvoicesForbidden: Boolean
  },
  data: function data() {
    return {
      form: {
        valid: false,
        loading: false
      },
      dialog: false,
      idDocument: null,
      idTag: null,
      documentType: null,
      documentTags: [],
      loadingDocumentTags: false,
      formRules: formRules
    };
  },
  created: function created() {
    this.fetchDocumentTags();
  },
  methods: {
    openDialog: function openDialog(idDocument, documentType) {
      this.idDocument = idDocument;
      this.documentType = documentType;
      this.dialog = true;
    },
    closeDialog: function closeDialog() {
      this.idDocument = null;
      this.idTag = null;
      this.documentType = null;
      this.dialog = false;
    },
    emitManageTagsDialog: function emitManageTagsDialog() {
      this.$emit("openManageTagsDialog");
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _this.loadingDocumentTags = true;
              _context.next = 4;
              return request("/v1/document-tags/all", "get", null, true, "api").then(function (response) {
                _this.documentTags = response.data.items;
                if (_this.isTagYourInvoicesForbidden) {
                  _this.documentTags = _this.documentTags.filter(function (x) {
                    return x.id !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId;
                  });
                }
                _this.loadingDocumentTags = false;
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addTagToDocument: function addTagToDocument() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this.form.loading = true;
              _context2.next = 4;
              return request("/v1/document-tags/type/".concat(_this.documentType.id), "post", {
                idTag: _this.idTag,
                idDocument: _this.idDocument
              }, true, "api").catch(function (e) {
                _this.$toasted.show("Document tag couldn't be Added.", {
                  type: "error"
                });
              });
            case 4:
              _this.form.loading = false;
              _this.$emit("tagAddedToDocument");
              _this.closeDialog();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};